import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Message from 'components/Message';
import { intlMessage } from 'constants/propTypes';
import { makePath } from 'helpers/link-generation';
import messages from './Schedules.messages';

export const AddScheduleButton = ({ className, message = messages.addClassSchedule, venueId, startDate }) => (
  <Link className={className} to={makePath.schedulesCreate({ venueId, startDate })}>
    <Message as={Button} styled="primary" message={message} />
  </Link>
);

AddScheduleButton.propTypes = {
  className: PropTypes.string,
  message: intlMessage,
  venueId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startDate: PropTypes.instanceOf(Date),
};
